<div class="card mt-4" *ngIf="upgrade" data-qa-id="Upgrade Widget">
  <div class="card-content">
    <div class="has-text-centered">
      <strong class="upgrade-custom-title" data-qa-id="Upgrade Custom Title" *ngIf="customTitle">{{
        customTitle
      }}</strong>
      <ng-container *ngIf="singleTestUpgrade; else standardUpgradeTemplate">
        <p class="mt-3">Upgrade with the</p>
        <h2 class="upgrade-title mb-0">{{ singleTestUpgrade }}</h2>
      </ng-container>
      <ng-template #standardUpgradeTemplate>
        <p>Upgrade to the</p>
        <h2 class="upgrade-title mb-0">{{ upgrade.name }}</h2>
        <small class="upgrade-subtitle" *ngIf="shouldDisplayAdditionalTests">And additionally get</small>
      </ng-template>
    </div>

    <ng-container *ngIf="upgradeItems.length > 0 && !singleTestUpgrade">
      <hr class="separator" />
      <div class="tests-container" [ngClass]="{ 'is-collapsed': !isExpanded && showReadMore }">
        <div #testsGrid class="tests-grid">
          <div *ngFor="let test of this.upgradeItems" class="child-test">
            <i class="fa fa-check"></i><span>{{ test }}</span>
          </div>
        </div>
        <button
          *ngIf="showReadMore"
          type="button"
          class="read-more-btn"
          (click)="toggleExpanded()"
          data-qa-id="Read More Toggle"
        >
          {{ isExpanded ? 'Show Less' : 'Show More' }}
        </button>
      </div>
    </ng-container>

    <hr class="separator" />

    <div class="columns is-vcentered">
      <div class="column is-7 upgrade__button_container">
        <button
          type="button"
          data-qa-id="Upgrade Submit"
          class="button is-large is-fullwidth has-text-white is-orange action"
          (click)="upgradeOrder()"
        >
          <span>Upgrade Now</span>
        </button>
      </div>
      <div class="column is-5 has-text-right upgrade__price_container">
        <span class="upgrade-title mb-0 is-text-secondary-green" data-qa-id="Upgrade Additional Cost">
          +{{ this.extraCost | centsCurrency }}
        </span>
      </div>
    </div>
  </div>
</div>
